import React from 'react';

export function Table({ children, className = '', striped = false, hover = false }) {
    return (
        <div className="overflow-x-auto">
            <table
                className={`w-full border-collapse bg-white dark:bg-gray-800 ${className}`}
            >
                {children}
            </table>
        </div>
    );
}

export function TableHead({ children }) {
    return (
        <thead className="bg-gray-50 dark:bg-gray-700">
            {children}
        </thead>
    );
}

export function TableBody({ children }) {
    return <tbody className="divide-y divide-gray-200 dark:divide-gray-600">{children}</tbody>;
}

export function TableRow({ children, hover = false, className = '' }) {
    return (
        <tr
            className={`${hover ? 'hover:bg-gray-50 dark:hover:bg-gray-700' : ''} ${className}`}
        >
            {children}
        </tr>
    );
}

export function TableCell({ children, align = 'left', className = '', ...props }) {
    const alignClasses = {
        left: 'text-left',
        center: 'text-center',
        right: 'text-right'
    };

    return (
        <td
            className={`px-4 py-3 text-gray-900 dark:text-white ${alignClasses[align]} ${className}`}
            {...props}
        >
            {children}
        </td>
    );
}

export function TableHeader({ children, align = 'left', className = '' }) {
    const alignClasses = {
        left: 'text-left',
        center: 'text-center',
        right: 'text-right'
    };

    return (
        <th
            className={`px-4 py-3 font-semibold text-gray-700 dark:text-gray-300 ${alignClasses[align]} ${className}`}
        >
            {children}
        </th>
    );
}
